import { useContext } from 'react'

import {
  NavigationBlockContext,
  NavigationBlockContextValue,
} from '../navigationBlockContext'

/**
 * Hook to access navigation block context
 * @throws Error if used outside NavigationBlockProvider
 */
export const useNavigationBlockContext = (): NavigationBlockContextValue => {
  const context = useContext(NavigationBlockContext)
  if (!context) {
    throw new Error(
      'useNavigationBlockContext must be used within NavigationBlockProvider'
    )
  }
  return context
}
